// extracted by mini-css-extract-plugin
module.exports = {"procedureName":"styles_procedureName__23WLO","colMin":"styles_colMin__1cRN7","colCheckbox":"styles_colCheckbox__39hz1"};